// Metadata
const updateMetadataButton = document.getElementById("update-metadata");
const cancelMetadataUpdate = document.getElementById("cancel-edit-metadata");
if (updateMetadataButton != null)
  updateMetadataButton.addEventListener("click", toggleEditMetadata);
if (cancelMetadataUpdate != null)
  cancelMetadataUpdate.addEventListener("click", toggleEditMetadata);

function toggleEditMetadata() {
  const metadataBoxes = document.getElementsByClassName("metadata-box");
  const editBox = document.getElementById("edit-metadata-box");

  if (metadataBoxes == null || editBox == null) return;

  if (editBox.classList.contains("hidden")) {
    for (const box of metadataBoxes) {
      box.classList.add("hidden");
    }
    editBox.classList.remove("hidden");
  } else {
    for (const box of metadataBoxes) {
      box.classList.remove("hidden");
    }
    editBox.classList.add("hidden");

    //Reset form
    document.getElementById("wppb-edit-user-profile-metadata").reset();
  }
}

// Image
const updateImageButton = document.getElementById("update-image");
const cancelImageUpdate = document.getElementById("cancel-edit-image");
if (updateImageButton != null)
  updateImageButton.addEventListener("click", toggleEditImage);
if (cancelImageUpdate != null)
  cancelImageUpdate.addEventListener("click", toggleEditImage);

function toggleEditImage() {
  const imageBox = document.getElementById("image-box");
  const editBox = document.getElementById("edit-avatar-box");

  if (imageBox == null || editBox == null) return;

  if (editBox.classList.contains("hidden")) {
    imageBox.classList.add("hidden");
    editBox.classList.remove("hidden");
  } else {
    imageBox.classList.remove("hidden");
    editBox.classList.add("hidden");
    document.getElementById("wppb-edit-user-profile-avatar").reset();
  }
}

// Password
const updatePasswordButton = document.getElementById("update-password");
const cancelPasswordUpdate = document.getElementById("cancel-edit-password");
if (updatePasswordButton != null)
  updatePasswordButton.addEventListener("click", toggleEditPassword);
if (cancelPasswordUpdate != null)
  cancelPasswordUpdate.addEventListener("click", toggleEditPassword);

function toggleEditPassword() {
  const passwordBox = document.getElementById("password-box");
  const editBox = document.getElementById("edit-password-box");

  if (passwordBox == null || editBox == null) return;

  if (editBox.classList.contains("hidden")) {
    passwordBox.classList.add("hidden");
    editBox.classList.remove("hidden");
  } else {
    passwordBox.classList.remove("hidden");
    editBox.classList.add("hidden");
    document.getElementById("wppb-edit-user-profile-password").reset();
  }
}

// GDPR request from relates JS (solves captcha + fixes placeholder)
const captchaInput = document.getElementById("gdrf_data_human");
if (captchaInput != null) {
  captchaInput.removeAttribute("required");
  const captchaLabel = document
    .getElementsByClassName("gdrf-field-human")[0]
    .getElementsByTagName("label")[0];
  const captchaText = captchaLabel.innerText;
  const nr1 = captchaText.match(/[-+]?\d*(\.(?=\d))?\d+/g)[0];
  const nr2 = captchaText.match(/[-+]?\d*(\.(?=\d))?\d+/g)[1];
  const nr3 = parseInt(nr1) + parseInt(nr2);
  const answer = document.getElementById("gdrf_data_human");
  answer.innerText = nr3;
  answer.value = nr3;
  document.getElementById("gdrf_data_email").placeholder = "Sähköpostiosoite";
}

// Moves form general messages into message div.
const originalMessage = document.getElementById("wppb_form_general_message");
if (originalMessage !== null) {
  //Clones message
  const clonedMessage = originalMessage.cloneNode(true);
  const messageBox = document.getElementById("message-box");

  if (clonedMessage != null || messageBox != null) {
    // Remove ID from cloned message
    clonedMessage.removeAttribute("id");

    // Remove original message from DOM
    originalMessage.remove();

    // Appends cloned message to messagebox div
    messageBox.appendChild(clonedMessage);
  }
}
